<template>
    <label :class="{ 'checked': currentValue == value }">
        <input type="radio" :name="name" :id="name + ' - ' + value" :value="value" @click="radioSelected" />
        <span class="check"></span>
        <img v-if="imgSrc" :src="imgSrc" />
        <div class="text">
            <slot></slot>
        </div>

        <div v-if="price" class="price">
            &euro; {{price}}
        </div>

        <div class="info-icon"  v-if="info !== undefined">
            <span class="mdi mdi-information-outline"  v-b-popover.hover="info" :title="name"></span>
        </div>
    </label>
</template>

<script>
    import { EventBus } from '../../services/eventBus'

    export default {
        name: "info-radio",
        props: {
            name: String,
            value: String,
            price: Number,
            imgSrc: String,
            currentValue: String,
            info: String,
            id: Number
        },
        data () {
            return {
                isChecked: false
            }
        },
        methods: {
            sendSelected() {
              let x = document.getElementById(this.name + ' - ' + this.value)
              let MechObj = {parent: this.name, name: this.value, id: this.id, price: this.price, checked: x.checked};
              EventBus.$emit('MechSelected', MechObj);
            },
            radioSelected() {
                EventBus.$emit('radio-button::new-value', this.value, this.name);
            }
        },
        mounted () {
          EventBus.$on('radio-button::new-value', this.sendSelected)
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/InfoRadio.vue